
import { types, actions } from './requests'
export const UPLOADMULTIPLEFILES_TYPES = {
    ...types('UPLOADMULTIPLEFILES'),
}
export const UPLOADMULTIPLEFILES_ACTIONS = {
    ...actions('UPLOADMULTIPLEFILES'),
}